import { actionOnMessage } from '@skynet/data-ws-mm';

import { cancelReport, confirmReport, requestReport } from './actions';
import { initialReportSlice, createReportsExtraReducers } from 'src/store/shared/reports/factory';
import type { ReportsState } from 'src/store/shared/reports/factory';

export const initialState: ReportsState = {
  requestStatus: null,
  error: null,

  reportPreview: null,
  reportId: null,
};

const { reducer, actions } = initialReportSlice({
  prefix: 'loans',
  sliceName: 'reports',
  initialState,
  messages: actionOnMessage,
  extraReducers: createReportsExtraReducers(requestReport, confirmReport, cancelReport),
});

export const reportsActions = {
  ...actions,
  requestReport,
  confirmReport,
  cancelReport,
};

export default reducer;
